import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { pdfFiles, PDFdownloadButton } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const RewardProgram = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={[pdfFiles.strategiesPart1[3], pdfFiles.strategiesPart1[4]]}
        vidSrc={1194418540}
      />
    </div>
  );
};

export default RewardProgram;
